// extracted by mini-css-extract-plugin
export default {"mainPageContainer":"page404_mainPageContainer__JvoKq","errorContainer":"page404_errorContainer__RW1+4"};